import type { IAboutUsPayload } from "@model/Aboutus.model";
import aboutus from "Utils/Assets/Images/Aboutus.webp"
export const aboutMock: IAboutUsPayload = {
  intro: {
    title: "We automate everything that should be automatic",
    subtitle:
      "No stats. Just story. From everyday routines to complex ops, ChimeraTech turns manual grind into invisible systems—so people can focus on what only humans can do.",
    pills: [
      { label: "Automation with taste" },
      { label: "Speed, safely" },
      { label: "Human-centered" },
    ],
     imageSrc:aboutus,
  },

  vision: {
    title: "Our Vision",
    subtitle:
      "At ChimeraTech, we envision a future where every process can be transformed into seamless automation.",
    cards: [
      {
        title: "Transforming the Ordinary into Extraordinary",
        description:
          "We turn manual, repetitive, time-consuming tasks into automated experiences that run silently in the background.",
      },
      {
        title: "Automation Powered by Intelligent Controllers",
        description:
          "Controllers that connect systems, analyze data, and adapt in real-time to keep operations at their peak.",
      },
      {
        title: "A World Fully Automated",
        description:
          "Automation becomes the standard so teams focus on innovation, creativity, and human connection.",
      },
    ],
  },

  whatWeDo: {
    title: "What We Do",
    subtitle:
      "A full-stack automation suite—software, hardware, and lab integrations—so your teams move faster with less friction.",
    items: [
      {
        title: "Software Development",
        description: "Web & mobile apps, scalable backends, DevOps automation.",
        iconKey: "software",
      },
      {
        title: "Hardware Development",
        description: "Embedded systems, IoT controllers, custom electronics.",
        iconKey: "hardware",
      },
      {
        title: "System Integration",
        description: "Bridge your existing infrastructure into a unified ecosystem.",
        iconKey: "system",
      },
    ],
  },

  teamGroups: [
    {
      groupName: "Leadership",
      description: "Guiding the vision and keeping quality high.",
      members: [
        {
          name: "Rana Lamia",
          title: "CEO",
          photoUrl: "https://i.pinimg.com/1200x/a0/0d/83/a00d83e9e13a873d1f17efaa714f59c2.jpg",
          summary: "Strategy, hiring, partnerships.",
        },
        {
          name: "Karim S.",
          title: "CTO",
          photoUrl: "https://i.pinimg.com/736x/d9/b6/1a/d9b61a74e0ca7c64d50d27bb42013b4b.jpg",
          summary: "Architecture, security, AI systems.",
        },
         {
          name: "Nour H.",
          title: "Frontend Engineer",
          photoUrl: "https://i.pinimg.com/736x/f6/61/ea/f661ea61616909838a9fbfeda0d2ea14.jpg",
          summary: "React, UX, performance.",
        },
          {
          name: "Rana Lamia",
          title: "CEO",
          photoUrl: "https://i.pinimg.com/1200x/a0/0d/83/a00d83e9e13a873d1f17efaa714f59c2.jpg",
          summary: "Strategy, hiring, partnerships.",
        },
        {
          name: "Karim S.",
          title: "CTO",
          photoUrl: "https://i.pinimg.com/736x/d9/b6/1a/d9b61a74e0ca7c64d50d27bb42013b4b.jpg",
          summary: "Architecture, security, AI systems.",
        },
         {
          name: "Nour H.",
          title: "Frontend Engineer",
          photoUrl: "https://i.pinimg.com/736x/f6/61/ea/f661ea61616909838a9fbfeda0d2ea14.jpg",
          summary: "React, UX, performance.",
        },
         {
          name: "Jad A.",
          title: "Backend Engineer",
          photoUrl: "https://i.pinimg.com/736x/5d/ea/c3/5deac3296927862d06e73661c1bb7720.jpg",
          summary: "APIs, data, reliability.",
        },
      ],
    },
    {
      groupName: "Engineering",
      description: "Full-stack builders turning ideas into products.",
      members: [
        {
          name: "Nour H.",
          title: "Frontend Engineer",
          photoUrl: "https://i.pinimg.com/736x/f6/61/ea/f661ea61616909838a9fbfeda0d2ea14.jpg",
          summary: "React, UX, performance.",
        },
        {
          name: "Jad A.",
          title: "Backend Engineer",
          photoUrl: "https://i.pinimg.com/736x/5d/ea/c3/5deac3296927862d06e73661c1bb7720.jpg",
          summary: "APIs, data, reliability.",
        },
         
      ],

    },
    
  ],
};
